import { render } from "./ContainerStyles.vue?vue&type=template&id=2918cd5c&scoped=true"
import script from "./ContainerStyles.vue?vue&type=script&lang=js"
export * from "./ContainerStyles.vue?vue&type=script&lang=js"

import "./ContainerStyles.vue?vue&type=style&index=0&id=2918cd5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2918cd5c"]])

export default __exports__